module.exports = __webpack_public_path__ + "static/media/ic-close.f21e692a.svg";